if (!customElements.get("purchase-detail-loader")) {
  class PurchaseDetailLoader extends HTMLElement {
    connectedCallback() {
      const img = this.querySelector(".ppc-detail-image");
      if (!img) {
        return;
      }

      if (img.complete && img.naturalWidth > 0) {
        if (this.isPlaceholderImage(img)) {
          const fallbacks = this.getFallbackUrls();
          if (fallbacks.length) {
            this.tryFallback(img, fallbacks, 0);
          } else {
            this.handleFailure();
          }
        } else {
          this.markLoaded();
        }
        return;
      }

      const fallbacks = this.getFallbackUrls();
      if (!fallbacks.length) {
        img.addEventListener(
          "error",
          () => {
            this.handleFailure();
          },
          { once: true }
        );
        return;
      }

      img.addEventListener("error", () => {
        this.tryFallback(img, fallbacks, 0);
      });

      img.addEventListener("load", () => {
        if (this.isPlaceholderImage(img)) {
          img.dispatchEvent(new Event("error"));
          return;
        }
        this.markLoaded();
      });

      if (img.complete && img.naturalWidth === 0) {
        img.dispatchEvent(new Event("error"));
      } else if (img.complete && img.naturalWidth > 0) {
        this.markLoaded();
      }
    }

    getFallbackUrls() {
      const node = this.querySelector("[data-ppc-detail-fallbacks]");
      if (!node) {
        return [];
      }

      try {
        const parsed = JSON.parse(node.textContent || "[]");
        return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
      } catch (error) {
        console.error(error);
        return [];
      }
    }

    tryFallback(img, urls, index) {
      if (index >= urls.length) {
        this.handleFailure();
        return;
      }

      const onError = () => {
        img.removeEventListener("load", onLoad);
        this.tryFallback(img, urls, index + 1);
      };

      const onLoad = () => {
        img.removeEventListener("error", onError);
        if (this.isPlaceholderImage(img)) {
          this.tryFallback(img, urls, index + 1);
          return;
        }
        this.markLoaded();
      };

      img.addEventListener("error", onError, { once: true });
      img.addEventListener("load", onLoad, { once: true });
      img.src = urls[index];
    }

    markLoaded() {
      this.classList.add("ppc-detail-media-loaded");
    }

    isPlaceholderImage(img) {
      const src = img.currentSrc || img.src || "";
      return /no[-_]image|placeholder/i.test(src) || (img.naturalWidth <= 1 && img.naturalHeight <= 1);
    }

    handleFailure() {
      if (this.dataset.keepVisible === "true") {
        return;
      }

      const section = this.closest(".shopify-section");
      if (section) {
        section.hidden = true;
      }
    }
  }

  customElements.define("purchase-detail-loader", PurchaseDetailLoader);
}
